export default "__VITE_ASSET__DNau8zKp__"